import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Organization } from '../Organization';
import { NewUser } from '../User';
export class CreateOrganization extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.registerCode = null;
    }
}
__decorate([
    field({ decoder: Organization })
], CreateOrganization.prototype, "organization", void 0);
__decorate([
    field({ decoder: NewUser })
], CreateOrganization.prototype, "user", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 24 })
], CreateOrganization.prototype, "registerCode", void 0);
//# sourceMappingURL=CreateOrganization.js.map